import { Disclosure } from "@headlessui/react";
import { logout } from "../../firebase/firebase.user";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { removeUserState } from "../../store/user/user.reducer";
import { removePraxisState } from "../../store/praxis/praxis.reducer";
import FeedbackModal from "../feedback/FeedbackModal";
import NameAvatar from "../UI/NameAvatar";
import { useState } from "react";
import toast from "react-hot-toast";

export default function Navbar({ children }) {
  const [isShowing, setIsShowing] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user?.userDetails);

  const logoutHandler = () => {
    logout();
    dispatch(removeUserState());
    dispatch(removePraxisState());
    navigate("/");
  };

  const showUserDetails = () => {
    toast.custom(
      (t) => (
        <div
          className={`${
            t.visible ? "animate-enter" : "animate-leave"
          } max-w-xs bg-white shadow-lg rounded-lg pointer-events-auto flex flex-col ring-1 ring-black ring-opacity-5`}
        >
          <div className="flex-1 p-3">
            <div className="flex items-start">
              <div className="ml-1">
                <p className="text-sm font-medium text-gray-900">
                  Nombre: {user?.name}
                </p>
                <p className="mt-1 text-sm text-gray-500">
                  Consultorio: {user?.praxis}
                </p>
                <p className="mt-1 text-sm text-gray-500">
                  Role:
                  {user?.role === "user" && " Usuario/a"}
                  {user?.role === "owner" && " Dueño/a"}
                  {user?.role === "admin" && " Admin"}
                </p>
              </div>
            </div>
          </div>
          <div className="flex border-l border-gray-200">
            <button
              onClick={() => {
                toast.dismiss(t.id);
                setIsShowing(false);
              }}
              className="w-full border border-transparent rounded-none rounded-r-lg p-3 flex items-center justify-center text-sm font-medium text-slate-800 hover:text-slate-700"
            >
              Cerrar
            </button>
          </div>
        </div>
      ),
      {
        position: "botton-left",
        duration: 4000,
      }
    );

    setTimeout(() => {
      setIsShowing(false);
    }, "4000");
  };

  return (
    <Disclosure as="nav" style={{ backgroundColor: "#253141" }}>
      {({ open }) => (
        <div className="h-screen flex flex-col overflow-hidden">
          {/* Fixed Top Navbar */}
          <div className="flex-shrink-0 px-2">
            <div className="relative flex h-16 items-center justify-between">
              <div className="flex items-center justify-center sm:items-stretch sm:justify-start sm:w-1/3">
                <div className="flex flex-shrink-0 items-center">
                  <div className="lg:mb-0 lg:ml-[4vw]">
                    <svg
                      version="1.2"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 670 107"
                      className="h-[4.5vh]"
                    >
                      <g id="Layer">
                        <g id="Layer">
                          <path
                            id="Layer"
                            className="fill-white"
                            d="m385.5 68l5.9-7c5.3 4.6 10.7 7.2 17.5 7.2 6 0 9.9-2.9 9.9-7v-0.1c0-4-2.3-6.2-12.6-8.5-11.8-2.9-18.5-6.4-18.5-16.6v-0.2c0-9.5 7.9-16.1 19-16.1 8.1 0 14.5 2.4 20.2 7l-5.3 7.4c-5-3.8-10-5.8-15.1-5.8-5.7 0-9 3-9 6.6v0.2c0 4.3 2.5 6.2 13.2 8.7 11.8 2.9 17.8 7.1 17.8 16.3v0.2c0 10.4-8.2 16.6-19.8 16.6-8.5 0-16.6-3-23.2-8.9z"
                          />
                          <path
                            id="Layer"
                            className="fill-white"
                            d="m452.5 29.5h-17.6v-9h45.1v9h-17.7v46.6h-9.8z"
                          />
                          <path
                            id="Layer"
                            className="fill-white"
                            d="m578.1 55c7.7-2.2 13.2-7.7 13.2-16.8v-0.2c0-4.8-1.7-9-4.6-12-3.6-3.5-9.1-5.5-16.1-5.5h-24.7v55.6h9.7v-46.7h14.3c7.2 0 11.5 3.2 11.5 9.2v0.1c0 5.7-4.5 9.3-11.5 9.3h-7.9l19.5 28.1h11.6z"
                          />
                          <path
                            id="Layer"
                            className="fill-white"
                            d="m488.4 76.1h-9.9l24.4-56h9l24.5 56h-10.3l-18.9-44.4z"
                          />
                          <path
                            id="Layer"
                            className="fill-white"
                            d="m603.4 20.5h9.7v55.6h-9.7z"
                          />
                          <path
                            id="Layer"
                            className="fill-white"
                            d="m651.5 20.5h-12l-22.6 23.9 23.7 31.6h12l-24.1-31.6z"
                          />
                        </g>
                        <g id="Layer">
                          <g id="Layer">
                            <path
                              id="Layer"
                              className="fill-white"
                              d="m249.6 20.4v38.4l-29.7-38.4h-11.7l2.7 3.5 16.9 21.9 23.3 30.2h8.2v-55.6z"
                            />
                            <path
                              id="Layer"
                              className="fill-white"
                              d="m210.9 36.1v39.9h9.6v-27.4z"
                            />
                          </g>
                          <path
                            id="Layer"
                            fillRule="evenodd"
                            className="fill-white"
                            d="m43.9 76.9q-6.5 0-11.8-2.3-5.3-2.2-9.1-6.1-3.8-3.9-6-9.1-2.1-5.2-2.1-11.1v-0.1q0-5.9 2.1-11.1 2.2-5.2 6.1-9.1 3.9-4 9.2-6.3 5.3-2.3 11.7-2.3 6.5 0 11.8 2.3 5.3 2.2 9.1 6.1 3.8 3.9 6 9.1 2.1 5.2 2.1 11.1v0.2q0 5.8-2.1 11-2.2 5.2-6.1 9.2-3.9 3.9-9.2 6.2-5.3 2.3-11.7 2.3zm0.1-9q4.1 0 7.6-1.5 3.4-1.6 5.9-4.2 2.4-2.7 3.8-6.3 1.4-3.5 1.4-7.6v-0.1q0-4.1-1.4-7.7-1.4-3.6-3.9-6.3-2.5-2.6-5.9-4.2-3.5-1.6-7.6-1.6-4.1 0-7.6 1.5-3.4 1.6-5.9 4.3-2.4 2.6-3.8 6.2-1.4 3.6-1.4 7.6v0.2q0 4 1.4 7.6 1.4 3.6 3.9 6.3 2.5 2.7 5.9 4.2 3.5 1.6 7.6 1.6z"
                          />
                          <path
                            id="Layer"
                            fillRule="evenodd"
                            className="fill-white"
                            d="m171.1 76.9q-6.5 0-11.8-2.3-5.3-2.2-9.1-6.1-3.8-3.9-6-9.1-2.1-5.2-2.1-11.1v-0.1q0-5.9 2.1-11.1 2.2-5.2 6.1-9.1 3.9-4 9.2-6.3 5.3-2.3 11.7-2.3 6.5 0 11.8 2.3 5.3 2.2 9.1 6.1 3.8 3.9 6 9.1 2.1 5.2 2.1 11.1v0.2q0 5.8-2.1 11-2.2 5.2-6.1 9.2-3.8 3.9-9.2 6.2-5.3 2.3-11.7 2.3zm0.1-9q4.2 0 7.6-1.5 3.4-1.6 5.9-4.2 2.4-2.7 3.8-6.3 1.4-3.5 1.4-7.6v-0.1q0-4.1-1.4-7.7-1.4-3.6-3.9-6.3-2.4-2.6-5.9-4.2-3.5-1.6-7.6-1.6-4.1 0-7.6 1.5-3.4 1.6-5.9 4.3-2.4 2.6-3.8 6.2-1.4 3.6-1.4 7.6v0.2q0 4 1.4 7.6 1.4 3.6 3.9 6.3 2.5 2.7 5.9 4.2 3.5 1.6 7.6 1.6z"
                          />
                          <path
                            id="Layer"
                            className="fill-white"
                            d="m286.1 29.4h-17.7v-9h45.1v9h-17.6v46.6h-9.8z"
                          />
                          <path
                            id="Layer"
                            fillRule="evenodd"
                            className="fill-white"
                            d="m349.2 76.9q-6.5 0-11.8-2.3-5.3-2.2-9.1-6.1-3.8-3.9-6-9.1-2.1-5.2-2.1-11.1v-0.1q0-5.9 2.1-11.1 2.2-5.2 6.1-9.1 3.9-4 9.2-6.3 5.3-2.3 11.7-2.3 6.5 0 11.8 2.3 5.3 2.2 9.1 6.1 3.8 3.9 6 9.1 2.1 5.2 2.1 11.1v0.2q0 5.8-2.1 11-2.2 5.2-6.1 9.2-3.8 3.9-9.2 6.2-5.3 2.3-11.7 2.3zm0.1-9q4.2 0 7.6-1.5 3.4-1.6 5.9-4.2 2.4-2.7 3.8-6.3 1.4-3.5 1.4-7.6v-0.1q0-4.1-1.4-7.7-1.4-3.6-3.9-6.3-2.4-2.6-5.9-4.2-3.5-1.6-7.6-1.6-4.1 0-7.6 1.5-3.4 1.6-5.9 4.3-2.4 2.6-3.8 6.2-1.4 3.6-1.4 7.6v0.2q0 4 1.4 7.6 1.4 3.6 3.9 6.3 2.5 2.7 5.9 4.2 3.5 1.6 7.6 1.6z"
                          />
                          <path
                            id="Layer"
                            className="fill-white"
                            d="m131.8 37.1q-2.2-5.1-6.1-8.8-3.9-3.7-9.4-5.8-5.4-2.1-11.9-2.1h-20.7v8.8h9.7 10.9q4.4 0 8 1.4 3.5 1.4 6 4 2.5 2.5 3.9 6 1.4 3.5 1.4 7.5v0.2q0 4.1-1.4 7.5-1.4 3.5-3.9 6-2.5 2.5-6 3.9-3.6 1.4-8 1.4h-10.9v-23.2h-9.7v32h20.7q6.5 0 11.9-2.1 5.5-2.1 9.4-5.9 3.9-3.7 6.1-8.8 2.1-5.1 2.1-11v-0.1q0-5.9-2.1-10.9z"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>

              <div className="flex">
                {user && user?.role !== "admin" && <FeedbackModal />}

                <div className="flex">
                  <button
                    className="inline-flex items-center justify-center rounded-md p-2 text-white hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                    onClick={logoutHandler}
                  >
                    Salir
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Content Area with Fixed Side Nav and Scrollable Content */}
          {user && user?.role === "admin" && (
            <div
              className="flex-1 flex lg:flex-row flex-col overflow-hidden"
              style={{ backgroundColor: "#253141" }}
            >
              {/* Fixed Side Navigation - Admin */}
              <div className="lg:fixed lg:left-0 lg:top-16 lg:h-[calc(100vh-4rem)] lg:w-[5vw] xl:w-[4vw] 2xl:w-[5vw] flex lg:flex-col flex-row items-center bg-inherit z-40">
                <div className="flex lg:flex-col flex-row w-full lg:mt-10">
                  <Link className="py-4 px-2" to={"/errors"}>
                    <div className="flex flex-col justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="white"
                        className="w-6 h-6 lg:flex hidden"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                        />
                      </svg>
                      <h1 className="text-xs lg:text-sm font-bold text-white tracking-tight">
                        Errores
                      </h1>
                    </div>
                  </Link>
                  <Link className="py-4 px-2" to={"/admin"}>
                    <div className="flex flex-col justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="white"
                        className="w-6 h-6 lg:flex hidden"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
                        />
                      </svg>
                      <h1 className="text-xs lg:text-sm font-bold text-white tracking-tight">
                        Admin
                      </h1>
                    </div>
                  </Link>
                  <Link className="py-4 px-2" to={"/privateRegister"}>
                    <div className="flex flex-col justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="white"
                        className="w-6 h-6 lg:flex hidden"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                        />
                      </svg>
                      <h1 className="text-xs lg:text-sm font-bold text-white tracking-tight">
                        Registrar
                      </h1>
                    </div>
                  </Link>
                </div>
              </div>

              {/* Scrollable Content Area - Admin */}
              <div className="flex-1 lg:ml-[5vw] xl:ml-[4vw] 2xl:ml-[5vw] overflow-y-auto">
                {children}
              </div>
            </div>
          )}

          {user && (user?.role === "user" || user?.role === "owner") && (
            <div
              className="flex-1 flex lg:flex-row flex-col overflow-hidden"
              style={{ backgroundColor: "#253141" }}
            >
              {/* Fixed Side Navigation - User/Owner */}
              <div className="lg:fixed lg:left-0 lg:top-16 lg:h-[calc(100vh-4rem)] lg:w-[5vw] xl:w-[4vw] 2xl:w-[5vw] flex lg:flex-col flex-row justify-between items-center bg-inherit z-40">
                <div className="flex lg:flex-col flex-row w-full">
                  <Link className="py-4 px-2" to={"/calendario"}>
                    <div className="flex flex-col justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="white"
                        className="w-8 h-8 lg:flex hidden"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                        />
                      </svg>
                      <div className="text-xs lg:hidden font-bold text-white tracking-tight">
                        Citas
                      </div>
                    </div>
                  </Link>
                  <Link className="py-4 px-2" to={"/dashboard"}>
                    <div className="flex flex-col justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="white"
                        className="w-7 h-7 lg:flex hidden"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
                        />
                      </svg>
                      <div className="text-xs lg:hidden font-bold text-white tracking-tight">
                        Pacientes
                      </div>
                    </div>
                  </Link>
                  <Link className="py-4 px-2" to={"/finanzas"}>
                    <div className="flex flex-col justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="white"
                        className="w-7 h-7 lg:flex hidden"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                        />
                      </svg>
                      <div className="text-xs lg:hidden font-bold text-white tracking-tight">
                        Finanzas
                      </div>
                    </div>
                  </Link>
                </div>
                <Link className="flex p-4 justify-center" to={"/ajustes"}>
                  <div
                    style={{
                      backgroundColor: "rgb(113 127 144)",
                      opacity: 0.7,
                    }}
                    className="relative inline-flex items-center justify-center w-8 h-8 rounded-full overflow-hidden"
                  >
                    {user && (
                      <NameAvatar name={user.name + " " + user.lastname} />
                    )}
                  </div>
                </Link>
              </div>

              {/* Scrollable Content Area - User/Owner */}
              <div className="flex-1 lg:ml-[5vw] xl:ml-[4vw] 2xl:ml-[5vw] overflow-y-auto rounded-lg">
                {children}
              </div>
            </div>
          )}

          {user && user?.role === "patient" && (
            <div
              className="flex-1 flex lg:flex-row flex-col overflow-hidden"
              style={{ backgroundColor: "#253141" }}
            >
              {/* Fixed Side Navigation - Patient */}
              <div className="lg:fixed lg:left-0 lg:top-16 lg:h-[calc(100vh-4rem)] lg:w-[4vw] xl:w-[4vw] 2xl:w-[4vw] flex lg:flex-col flex-row justify-between items-center bg-inherit z-40">
                <div className="flex lg:flex-col flex-row w-full lg:mt-2">
                  <Link
                    className="py-4 px-2"
                    to={`/self/${user?.patientRecordId}`}
                  >
                    <div className="flex flex-col justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        className="w-8 h-8 lg:flex hidden"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div className="text-xs lg:hidden font-bold text-white tracking-tight">
                        Perfil Medico
                      </div>
                    </div>
                  </Link>
                  <Link className="py-4 px-2" to={"/self/calendario"}>
                    <div className="flex flex-col justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="white"
                        className="w-8 h-8 lg:flex hidden"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                        />
                      </svg>
                      <div className="text-xs lg:hidden font-bold text-white tracking-tight">
                        Mis Citas
                      </div>
                    </div>
                  </Link>
                  <Link className="py-4 px-2" to={"/self/servicios"}>
                    <div className="flex flex-col justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-8 h-8 lg:flex hidden"
                      >
                        <path
                          d="M14.1679688,9.4453125l-1.5107422,2.265625-1.2099609-.6054688c-.3857422-.1933594-.8496094-.1181641-1.1542969,.1875l-2,2c-.390625,.390625-.390625,1.0234375,0,1.4140625,.1953125,.1953125,.4511719,.2929688,.7070312,.2929688s.5117188-.0976562,.7070312-.2929688l1.4902344-1.4902344,1.3554688,.6777344c.4511719,.2255859,1,.0791016,1.2792969-.3398438l2-3c.3066406-.4599609,.1826172-1.0800781-.2773438-1.3867188-.4619141-.3056641-1.0820312-.1826172-1.3867188,.2773438Z"
                          fill="#ffffff"
                        ></path>
                        <path
                          d="M20,12c0-1.8642578-.1025391-3.7451172-.3056641-5.5869141-.109375-1.0263672-.5595703-2.0029297-1.2724609-2.7558594-.4620361-.4813843-1.0140991-.8526001-1.6186523-1.0962524-.366272-.9220581-1.2556763-1.5609741-2.3032227-1.5609741h-5c-1.0476074,0-1.9370728,.638916-2.3032837,1.5610352-.6047974,.2438354-1.1577148,.6159668-1.6234741,1.1010742-.7080078,.7480469-1.1582031,1.7246094-1.2675781,2.7480469-.203125,1.8447266-.3056641,3.7255859-.3056641,5.5898438s.1025391,3.7451172,.3056641,5.5869141c.109375,1.0263672,.5595703,2.0029297,1.2744141,2.7578125,.7314453,.7578125,1.6611328,1.2363281,2.6845703,1.3847656,1.2392578,.1826172,2.4882812,.2734375,3.7363281,.2734375,1.2470703,0,2.4941406-.0908203,3.7324219-.2734375,1.0253906-.1484375,1.9550781-.6269531,2.6933594-1.3916016,.7080078-.7480469,1.1582031-1.7246094,1.2675781-2.7480469,.203125-1.8447266,.3056641-3.7255859,.3056641-5.5898438ZM15.0008545,3.4785156c.0004883,.0036011-.0009155,.0071411-.0003662,.0107422-.0001221-.00354-.0004883-.0087891-.0004883-.0107422h.0008545Zm-5.9852295-.046875c.0224609-.2460938,.2304688-.4316406,.484375-.4316406h5c.2539062,0,.4619141,.1855469,.484375,.4316406,.0039062,.0341797,.0078125,.0673828,.0146484,.0996094-.0166016,.2617188-.234375,.46875-.4990234,.46875h-5c-.2607422,0-.4755859-.2001953-.4980469-.4736328,.0058594-.03125,.0107422-.0625,.0136719-.0947266Zm8.6904297,13.9423828c-.0634766,.5927734-.3232422,1.1572266-.7255859,1.5820312-.4199219,.4355469-.9511719,.7099609-1.5361328,.7949219-2.2861328,.3359375-4.6044922,.3359375-6.890625,0-.5830078-.0849609-1.1142578-.359375-1.5273438-.7880859-.4091797-.4316406-.6689453-.9960938-.7324219-1.5917969-.1953125-1.7724609-.2939453-3.5800781-.2939453-5.3710938s.0986328-3.5986328,.2939453-5.3740234c.0634766-.5927734,.3232422-1.1572266,.7275391-1.5839844,.0996094-.1035156,.2060547-.1992188,.3183594-.2841797,.0112305,.019165,.0287476,.0335693,.0404663,.0524292,.2039795,.3287964,.4796143,.6047974,.8083496,.8088989,.0466309,.0289917,.0953979,.0523071,.144043,.0782471,.128418,.0684814,.2623291,.125,.402771,.1705322,.0547485,.0178223,.107666,.0369873,.1640015,.0509644,.1934204,.0480957,.392395,.0811157,.6005249,.0811157h5c.2080688,0,.4070435-.032959,.6004028-.0810547,.0566406-.0140991,.1098022-.0333252,.164917-.0512695,.1397705-.0453491,.2729492-.1016235,.4007568-.1696777,.0494385-.0263672,.098999-.0500488,.1464844-.0795898,.1642456-.1021118,.3197021-.2164917,.4556885-.3527222,.0019531-.0018921,.0032349-.0043335,.005127-.0062256,.1333618-.1344604,.2459717-.2873535,.3462524-.4490356,.0117188-.0189209,.0292969-.0333862,.0405273-.0526123,.1113281,.0839844,.2158203,.1777344,.3134766,.2792969,.4091797,.4316406,.6689453,.9960938,.7324219,1.5917969,.1953125,1.7724609,.2939453,3.5800781,.2939453,5.3710938s-.0986328,3.5986328-.2939453,5.3740234Z"
                          fill="#ffffff"
                        ></path>
                      </svg>
                      <div className="text-xs lg:hidden font-bold text-white tracking-tight">
                        Mis Tratamientos
                      </div>
                    </div>
                  </Link>
                </div>
              </div>

              {/* Scrollable Content Area - Patient */}
              <div className="flex-1 lg:ml-[4vw] xl:ml-[4vw] 2xl:ml-[4vw] overflow-y-auto rounded-lg">
                {children}
              </div>
            </div>
          )}

          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-2 pt-2 pb-3"></div>
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
}
